// Function loadTabbedPartnerContainerBlock loads the TabbedPartnerContainerBlock class by dynamically importing the js on demand if needed

export function loadTabbedPartnerContainerBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-tabbed-partner-container-block-chunk" */ '../widgets/tabbedPartnerContainerBlock').then(wg => {

		const { TabbedPartnerContainerBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="TabbedPartnerContainerBlock"]');

		if(!$wg) {
			// console.info('TabbedPartnerContainerBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="TabbedPartnerContainerBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new TabbedPartnerContainerBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new TabbedPartnerContainerBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the TabbedPartnerContainerBlock widget');

}
